export enum CropType {
  Custom = 'custom',
  Freeform = 'freeform',
  SocialMedia = 'socialMedia',
}
